import { render, staticRenderFns } from "./myPublish.vue?vue&type=template&id=e8dc7a5e&scoped=true&"
import script from "./myPublish.vue?vue&type=script&lang=js&"
export * from "./myPublish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8dc7a5e",
  null
  
)

export default component.exports